// import React, { useState, useRef, useCallback } from "react";
// import "react-quill/dist/quill.snow.css";
// import { usePostForm } from "../contexts/PostFormContext";
// import "../../../../css/admin/posts/Rtefield.css";
// import ReactQuill from "react-quill-new";

// export function RTEField() {
//   const quillRef = useRef(null);
//   const [content, setContent] = useState("");
//   const { data, handleData } = usePostForm();

//   // Custom image handler
//   const imageHandler = useCallback(() => {
//     const input = document.createElement("input");
//     input.setAttribute("type", "file");
//     input.setAttribute("accept", "image/*");
//     input.click();

//     input.onchange = () => {
//       const file = input.files[0];
//       if (file && file.type.startsWith("image/")) {
//         const reader = new FileReader();
//         reader.onload = () => {
//           const quill = quillRef.current.getEditor();
//           const range = quill.getSelection(true) || {
//             index: quill.getLength(),
//           };
//           quill.insertEmbed(range.index, "image", reader.result);
//         };
//         reader.readAsDataURL(file);
//       } else {
//         alert("Please select a valid image file");
//       }
//     };
//   }, []);

//   const modules = {
//     toolbar: {
//       container: [
//         [{ header: [1, 2, 3, 4, 5, 6, false] }],
//         ["bold", "italic", "underline", "strike", "blockquote"],
//         [{ size: ["extra-small", "small", "medium", "large"] }],
//         [{ list: "ordered" }, { list: "bullet" }],
//         ["link", "image", "video"],
//         [{ color: [] }, { background: [] }],
//         ["clean"],
//       ],
//       handlers: {
//         image: imageHandler,
//       },
//     },
//   };

//   const formats = [
//     "header",
//     "bold",
//     "italic",
//     "underline",
//     "strike",
//     "blockquote",
//     "size",
//     "list",
//     "link",
//     "image",
//     "video",
//     "color",
//     "background",
//   ];

//   const handleChange = useCallback(
//     (value) => {
//       setContent(value);
//       handleData("content", value);
//     },
//     [handleData]
//   );

//   return (
//     <div className="mb-3">
//       <label className="form-label">Enter your content</label>
//       <div style={{ minHeight: "500px" }}>
//         <ReactQuill
//           ref={quillRef}
//           theme="snow"
//           value={data?.content || content}
//           onChange={handleChange}
//           modules={modules}
//           formats={formats}
//           placeholder="Enter your content here..."
//           style={{ height: "500px" }}
//         />
//       </div>
//     </div>
//   );
// }


import React, { useState, useRef, useCallback } from "react";
import "react-quill/dist/quill.snow.css";
import { usePostForm } from "../contexts/PostFormContext";
import "../../../../css/admin/posts/Rtefield.css";
import ReactQuill from "react-quill-new";

export function RTEField() {
  const quillRef = useRef(null);
  const [content, setContent] = useState("");
  const { data, handleData } = usePostForm();

  // Custom image handler
  const imageHandler = useCallback(() => {
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", "image/*");
    input.click();

    input.onchange = () => {
      const file = input.files[0];
      if (file && file.type.startsWith("image/")) {
        const reader = new FileReader();
        reader.onload = () => {
          const quill = quillRef.current.getEditor();
          const range = quill.getSelection(true) || {
            index: quill.getLength(),
          };
          quill.insertEmbed(range.index, "image", reader.result);
        };
        reader.readAsDataURL(file);
      } else {
        alert("Please select a valid image file");
      }
    };
  }, []);

  const modules = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline", "strike", "blockquote"],
        [{ size: ["extra-small", "small", "medium", "large"] }],
        [{ list: "ordered" }, { list: "bullet" }],
        ["link", "image", "video"],
        [{ color: [] }, { background: [] }],
        ["clean"],
      ],
      handlers: {
        image: imageHandler,
      },
    },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "size",
    "list",
    "link",
    "image",
    "video",
    "color",
    "background",
  ];

  const handleChange = useCallback(
    (value) => {
      setContent(value);
      handleData("content", value);
    },
    [handleData]
  );

  return (
    <div className="mb-3">
      <label className="form-label">
        Enter your content <span className="text-danger">*</span>
      </label>
      <div style={{ minHeight: "500px" }}>
        <ReactQuill
          ref={quillRef}
          theme="snow"
          value={data?.content || content}
          onChange={handleChange}
          modules={modules}
          formats={formats}
          placeholder="Enter your content here..."
          style={{ height: "500px" }}
          required
        />
      </div>
    </div>
  );
}